export default __webpack_public_path__ + "static/media/auto-engine.1be16541.svg";